import { render, staticRenderFns } from "./DraftGearReview.vue?vue&type=template&id=6a6a06a4&"
import script from "./DraftGearReview.vue?vue&type=script&lang=js&"
export * from "./DraftGearReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports